import AwardedBestAnswerNotification from './AwardedBestAnswerNotification';
import BestAnswerBadge from './BestAnswerBadge';
import BestAnswerFooterPreview from './BestAnswerFooterPreview';
import BestAnswerInDiscussionNotification from './BestAnswerInDiscussionNotification';
import SelectBestAnswerItem from './SelectBestAnswerItem';
import SelectBestAnswerNotification from './SelectBestAnswerNotification';
import SolutionSearchItem from './SolutionSearchItem';
import SolvedFilter from './SolvedFilter';
export const components = {
  SelectBestAnswerItem,
  BestAnswerFooterPreview,
  AwardedBestAnswerNotification,
  BestAnswerBadge,
  BestAnswerInDiscussionNotification,
  SelectBestAnswerNotification,
  SolutionSearchItem,
  SolvedFilter
};
flarum.reg.add('fof-best-answer', 'forum/components', null);